var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('layout-blank',{staticStyle:{"padding":"5px"},attrs:{"id":"embeddedLayout"}},[_vm._t("default"),_c('div',{attrs:{"id":"bottom-identifier"}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }